enum AlertsOrderBy {
  DATE = 'Date',
}

export default AlertsOrderBy;
